import { get, set, type FieldErrors, type FieldValues, type Resolver } from "react-hook-form";
import type { ZodType } from "zod";

/**
 * Minimal react-hook-form resolver for zod schemas (first issue per field). Dotted issue paths
 * (`hours.mon.0.close`) become nested errors, which is the shape react-hook-form reads.
 */
export function zodResolver<T extends FieldValues>(schema: ZodType<T>): Resolver<T> {
  return (values) => {
    const result = schema.safeParse(values);
    if (result.success) return { values: result.data, errors: {} };
    const errors: Record<string, unknown> = {};
    for (const issue of result.error.issues) {
      const path = issue.path.join(".") || "root";
      if (!get(errors, path)) set(errors, path, { type: issue.code, message: issue.message });
    }
    return { values: {}, errors: errors as FieldErrors<T> };
  };
}
